import {useEffect} from "react";

import {useVersion, useVersionRealtimeSub} from "~/api/hooks/useVersion";

const isLocalHost = window.location.host.includes("localhost");
export const currentVersion = "1.0.5";
export const useVersionCheck = () => {
  useVersionRealtimeSub();
  const {data, isSuccess} = useVersion();

  useEffect(() => {
    if (!isLocalHost && isSuccess && currentVersion < data.version)
      window.location.reload();
  }, [data, isSuccess]);
};
